/// <amd-module name="SuiteCommerce.StockNotifications.Header"/>
define("SuiteCommerce.StockNotifications.Header", ["require", "exports", "underscore", "jQuery", "SuiteCommerce.StockNotifications.Utils", "suitecommerce_stock_notifications_header_account_link.tpl"], function (require, exports, _, jQuery, Utils_1, headerAccountLinkTpl) {
    "use strict";
    return {
        mountToApp: function (container) {
            this.addToNavigation(container);
        },
        addToNavigation: function (container) {
            var _this = this;
            var layout = container.getComponent('Layout');
            var myAccountMenuComponent = container.getComponent('MyAccountMenu');
            if (myAccountMenuComponent) {
                this.registerMenuEntry(myAccountMenuComponent);
            }
            layout.on('afterShowContent', function () {
                if (jQuery('a[name=settings]').length > 0) {
                    _this.addToNavigationFallback();
                    jQuery(window).on('resize', _this.addToNavigationFallback());
                }
                return {};
            });
        },
        addToNavigationFallback: function () {
            var subscriptionContainer = '#stock-notifications-subscriptions';
            // TS ignoring next line since we cannot create a valid definition of Templates for this case
            // @ts-ignore
            var linkHtmlStr = headerAccountLinkTpl({
                linkText: Utils_1.Utils.translate('Stock Subscriptions'),
                linkFragment: '/stock-subscriptions'
            });
            _.delay(function () {
                var target;
                target = jQuery('a[name=settings]').next('.header-menu-myaccount-level3');
                if (!jQuery(subscriptionContainer).length) {
                    target.append(linkHtmlStr);
                }
            }, 2000);
        },
        registerMenuEntry: function (myAccountMenuComponent) {
            if (myAccountMenuComponent) {
                myAccountMenuComponent.addGroup(this.getGroup());
                myAccountMenuComponent.addGroupEntry(this.getGroupEntry());
            }
        },
        getGroup: function () {
            return {
                id: 'stockNotifications',
                name: Utils_1.Utils.translate('Stock notifications'),
                index: 4
            };
        },
        getGroupEntry: function () {
            return {
                groupid: 'stockNotifications',
                id: 'stock-subscriptions',
                name: Utils_1.Utils.translate('Subscriptions'),
                url: 'stock-subscriptions',
                index: 1
            };
        },
    };
});
